import { round } from 'lodash';
import React from 'react';
import {
  DataForDesignDrawingsManifold,
  DataForDesignDrawingsRoom,
} from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { DisplayStyle } from './templates/DisplayStyle';
import { PortOrRoomRow } from './templates/PortOrRoomRow';

type Props = {
  manifold: DataForDesignDrawingsManifold;
  displayStyle?: DisplayStyle;
  roundValuesLessThan100ToZero?: boolean;
};
export const ShortfallRow = ({ manifold, displayStyle = 'PerPort', roundValuesLessThan100ToZero = false }: Props) => {
  const getValue = (room: DataForDesignDrawingsRoom) => {
    if (room.heatLossAndHeatOutput == null) {
      return '';
    }

    if (room.heatLossAndHeatOutput.shortfallInWatts < 100 && roundValuesLessThan100ToZero) {
      return 0;
    }

    return round(room.heatLossAndHeatOutput.shortfallInWatts, 0);
  };

  return <PortOrRoomRow name="Shortfall (W)" manifold={manifold} getValue={getValue} displayStyle={displayStyle} />;
};
